import React from "react";

import Logo from "../static/logo.svg";

const NavItems = [
  { link: "services", text: "Services" },
  { link: "tech", text: "Technologies" },
  { link: "about", text: "About" },
  { link: "contact", text: "Contact", className: "action-btn" },
];

const NavItem = ({ link, text, onClick, className }) => (
  <div
    className={className ? "nav-item " + className : "nav-item"}
    onClick={onClick}
  >
    <a href={"#" + link}>{text}</a>
  </div>
);

const toggleMenu = () => {
  document.getElementById("navbar").classList.toggle("open");
};

const closeMenu = () => {
  const navBar = document.getElementById("navbar");
  const menuIcon = document.getElementById("menu-icon");

  if (navBar.classList.contains("open")) {
    navBar.classList.remove("open");
    menuIcon.name = "menu-outline";
  }
};

const Bar = () => (
  <div id="navbar" className="nav">
    <div className="nav-brand">
      <a href="#">
        <img src={Logo} alt="YAS" className="nav-logo" />
      </a>
    </div>

    <button className="menu-button" onClick={toggleMenu}>
      <ion-icon id="menu-icon" name="menu-outline" size="large" />
    </button>

    <div id="nav-items" className="nav-items">
      {NavItems.map(({ link, text, className = null }) => (
        <NavItem
          key={link}
          link={link}
          text={text}
          onClick={closeMenu}
          className={className}
        />
      ))}
    </div>
  </div>
);

export { Bar };
